var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-menu absolute z-dropdown select-none",class:_vm.menuClasses},[_c('div',{staticClass:"z-dropdown overflow-hidden bg-white border border-50 shadow rounded-lg"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }